"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormHelperText.default;
  }
});

var _FormHelperText = _interopRequireDefault(require("./FormHelperText"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/FormHelperText/index.js
// module id = 229
// module chunks = 0